<template>
  <v-form @submit.prevent="onSubmit" :disabled="loading">
    <v-radio-group v-model="form.baseCurrency" label="Валюта">
      <v-radio
        v-for="currency of currencies"
        :key="currency.code"
        :label="currency.name"
        :value="currency.code"
      />
    </v-radio-group>
    <v-btn type="submit" color="primary" :loading="loading">Зберегти</v-btn>
  </v-form>
</template>

<script>
export default {
  name: "ChangeProfileForm",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    defaultCurrency: String,
  },
  data() {
    return {
      form: {
        baseCurrency: this.defaultCurrency,
      },
    };
  },
  computed: {
    currencies() {
      return [
        {
          name: "Гривня",
          code: "UAH",
        },
        {
          name: "Євро",
          code: "EUR",
        },
        {
          name: "Долар",
          code: "USD",
        },
      ];
    },
  },
  methods: {
    onSubmit() {
      this.$emit("change-profile", {
        baseCurrency: this.form.baseCurrency,
      });
    },
  },
};
</script>
